<template>
	<li class="nav-item dropdown" :class="{ show }" v-if="isLogin" v-clickaway="clickawayClose">
		<a href="#" class="navbar-nav-link dropdown-toggle caret-0" @click.prevent="openPopup">
			<i class="icon icon-bubble"></i>
			<span class="d-md-none ml-2">Сообщения</span>
			<span class="badge badge-pill bg-warning-400 ml-auto ml-md-0" v-if="totalMessagesCount > 0">{{ totalMessagesCount }}</span>
		</a>

		<div class="dropdown-menu dropdown-menu-right dropdown-content wmin-md-350" :class="{ show }">
			<div class="dropdown-content-header">
				<span class="font-weight-semibold">Сообщения</span>
			</div>

			<Tabs :activeTab="activeTab" @change="(index) => activeTab = Number(index)" navClass="nav nav-tabs nav-tabs-highlight border-bottom-0">
				<Tab caption="Сообщения" :badge="unreadUserMessages.length > 0 ? String(unreadUserMessages.length) : null">
					<div class="dropdown-scrollable" v-if="userMessages.length">
				<ul class="media-list">
							<template v-for="(message, i) of userMessages" :key="message.id">
						<li class="dropdown-item" v-if="i < 5">
							<div class="mr-2 position-relative" v-if="message.author">
								<img :src="avatar(message)" width="36" height="36" class="rounded-circle" />
							</div>

							<div class="media-body">
								<p class="mb-0">
									<router-link :to="message.route" v-if="message.route">
												<span class="text-muted message-text">{{ message.message }}</span>
									</router-link>
											<span class="text-muted message-text" v-else>{{ message.message }}</span>
								</p>
								<p class="mb-0">
									<router-link :to="`/user/${message.author}`" v-if="message.author">
										<span class="font-weight-semibold">{{ message.authorname }}</span>
									</router-link>
									<span class="text-muted float-right font-size-sm">{{ timeago(message.updated_at) }}</span>
								</p>
							</div>
						</li>
					</template>
				</ul>
			</div>

			<div class="dropdown-content-body" v-else>
						<span>У Вас нет сообщений от пользователей</span>
					</div>
				</Tab>

				<Tab caption="Служебные оповещения" :badge="unreadSystemMessages.length > 0 ? String(unreadSystemMessages.length) : null">
					<div class="dropdown-scrollable" v-if="systemMessages.length">
						<ul class="media-list">
							<template v-for="(message, i) of systemMessages" :key="message.id">
								<li class="dropdown-item" v-if="i < 5">
									<div class="mr-2 position-relative" v-if="message.author">
										<img :src="avatar(message)" width="36" height="36" class="rounded-circle" />
									</div>

									<div class="media-body">
										<p class="mb-0">
											<router-link :to="message.route" v-if="message.route">
												<span class="text-muted message-text">{{ message.message }}</span>
											</router-link>
											<span class="text-muted message-text" v-else>{{ message.message }}</span>
										</p>
										<p class="mb-0">
											<span class="text-muted float-right font-size-sm">{{ timeago(message.updated_at) }}</span>
										</p>
									</div>
								</li>
							</template>
						</ul>
			</div>

					<div class="dropdown-content-body" v-else>
						<span>У Вас нет служебных оповещений</span>
					</div>
				</Tab>
			</Tabs>

			<div class="dropdown-content-footer justify-content-between p-0 border-top">
				<router-link class="bg-light text-grey flex-fill py-2 text-center d-block" title="Все сообщения" to="/messages">
					Все сообщения
				</router-link>
				
			</div>
		</div>
	</li>
</template>

<script>
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

import { clickaway } from "@/mixins";
import { timeago } from '@/helpers/utils';
import { config } from "@/config";
import Tabs from '@/components/Tabs/Tabs.vue';
import Tab from '@/components/Tabs/Tab.vue';

export default defineComponent({
	components: {
		Tabs,
		Tab
	},
	mixins: [clickaway],

	methods: {
		clickawayClose(event) {
			this.clickaway_close = false;

			const path = event.path || (event.composedPath ? event.composedPath() : undefined);

			if (path) {
				for (const item of path) {
					if (item?.classList?.contains('dropdown-item') || item?.classList?.contains('dropdown-content-footer')) this.closePopup();
				}
			}
		},
		openSendMessage() {
			this.closePopup();
			this.router.push('/messages');
		},
		async openPopup() {
			// При открытии dropdown помечаем все сообщения как прочитанные
			if (!this.show) {
				await this.$store.dispatch('messagesMarkAsRead');
			}
			// Вызываем оригинальный метод из mixin
			if (this.show) {
				this.clickaway_close = true;
				this.closePopup();
			} else {
				setTimeout(() => { this.show = true }, 0);
			}
		}
	},

	setup() {
		const { state, dispatch } = useStore();
		const router = useRouter();
		const activeTab = ref(0);

		const avatar = (message) => `${config.server}/api/images/avatar/${message.avatar}`;

		// Разделяем сообщения на пользовательские и служебные
		// Служебные - это те, у которых есть route (системные уведомления)
		// Пользовательские - те, у которых нет route или route не системный
		const userMessages = computed(() => {
			return state.messages.filter((msg) => {
				// Если есть route и он начинается с /tables - это служебное
				if (msg.route && msg.route.startsWith('/tables/')) {
					return false;
				}
				// Остальные - пользовательские
				return true;
			});
		});

		const systemMessages = computed(() => {
			return state.messages.filter((msg) => {
				// Служебные - те, у которых route начинается с /tables
				return msg.route && msg.route.startsWith('/tables/');
			});
		});

		// Непрочитанные сообщения
		const unreadMessages = computed(() => {
			return state.messages.filter((msg) => !msg.readed);
		});

		const unreadUserMessages = computed(() => {
			return unreadMessages.value.filter((msg) => {
				if (msg.route && msg.route.startsWith('/tables/')) {
					return false;
				}
				return true;
			});
		});

		const unreadSystemMessages = computed(() => {
			return unreadMessages.value.filter((msg) => {
				return msg.route && msg.route.startsWith('/tables/');
			});
		});

		const userMessagesCount = computed(() => userMessages.value.length);
		const systemMessagesCount = computed(() => systemMessages.value.length);
		const totalMessagesCount = computed(() => unreadMessages.value.length);

		onMounted(() => {
			dispatch('messagesRead');
		})

		return {
			avatar,
			isLogin: computed(() => state.token && state.user.exp),
			messages: computed(() => state.messages),
			userMessages,
			systemMessages,
			unreadMessages,
			unreadUserMessages,
			unreadSystemMessages,
			userMessagesCount,
			systemMessagesCount,
			totalMessagesCount,
			timeago,
			activeTab,
			router
		}
	}
})
</script>

<style scoped>
.dropdown-content-footer {
	display: flex;
}

.dropdown-content-footer a {
	text-decoration: none;
}

.dropdown-content-footer a:hover {
	background-color: #f8f9fa !important;
}

.nav-tabs {
	margin: 0;
	padding: 0 1rem;
}

.tab-content {
	max-height: 300px;
	overflow-y: auto;
}

.message-text {
	white-space: pre-line; /* Сохраняем переносы строк */
}
</style>
